/* eslint-disable */
import styled, { css } from 'styled-components'

export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  // cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  margin-bottom: 8px;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`

export const RadioCircle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid black;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  cursor : pointer;

  ${({ checked }) =>
    checked &&
    css`
      border: 1px solid black;
      &::after {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: rgba(32, 32, 32, 0.6);
      }
    `}
`

export const RadioLabel = styled.label`
  font-size: 14px;
  color: rgba(32, 32, 32, 0.9);
  line-height: 1.4;
  cursor : pointer;
`

export const Error = styled.div`
  color: rgba(225, 25, 0, 1);
  font-size: 12px;
  margin-top: 4px;
`
